export default "__VITE_ASSET__04253192__"